// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/tools/v1/logfields.proto (package gitpod.tools.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/tools/v1/logfields.proto.
 */
export const file_gitpod_tools_v1_logfields: GenFile = /*@__PURE__*/
  fileDesc("Ch9naXRwb2QvdG9vbHMvdjEvbG9nZmllbGRzLnByb3RvEg9naXRwb2QudG9vbHMudjEiGAoITG9nRmllbGQSDAoEbmFtZRgBIAEoCTpWCghsb2dmaWVsZBIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYtOUDIAEoCzIZLmdpdHBvZC50b29scy52MS5Mb2dGaWVsZFIIbG9nZmllbGRCQ1pBZ2l0aHViLmNvbS9naXRwb2QtaW8vZ2l0cG9kLW5leHQvYXBpL2dvL3Rvb2xzL2xvZ2ZpZWxkcztsb2dmaWVsZHNiBnByb3RvMw", [file_google_protobuf_descriptor]);

/**
 * @generated from message gitpod.tools.v1.LogField
 */
export type LogField = Message<"gitpod.tools.v1.LogField"> & {
  /**
   * name of the log context field where the value of this field should be
   * recorded. Fields with empty names are ignored.
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message gitpod.tools.v1.LogField.
 * Use `create(LogFieldSchema)` to create a new message.
 */
export const LogFieldSchema: GenMessage<LogField> = /*@__PURE__*/
  messageDesc(file_gitpod_tools_v1_logfields, 0);

/**
 * logfield indicates if and how the annotated field should be included as
 * context in log messages. This applies when a log message is generated
 * while processing a proto message that contains the field (directly or via
 * an embedded message).
 *
 * @generated from extension: gitpod.tools.v1.LogField logfield = 62132;
 */
export const logfield: GenExtension<FieldOptions, LogField> = /*@__PURE__*/
  extDesc(file_gitpod_tools_v1_logfields, 0);

